import { render } from "./ClientUserDashboard.vue?vue&type=template&id=1dc8792a&ts=true"
import script from "./ClientUserDashboard.vue?vue&type=script&lang=ts"
export * from "./ClientUserDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
